import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="dark-section" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <h1>404</h1>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-gold">Back to Home</Link>
      </div>
    </div>
  );
}
